export default __webpack_public_path__ + "static/media/welcome-female@2x.efe332af.png";